import { defineRecipe } from '@chakra-ui/react';

/** Chakra ships no `text` recipe, and an empty recipe className is dropped, so this registers one only to emit
 * `chakra-text`, which repo SCSS and `css` props select on. Class-only: a `base` block would style every Text. */
export const textRecipe = defineRecipe({
  className: 'chakra-text',
});
